module.exports = __webpack_public_path__ + "static/media/Fakegram.4bb38418.png";